import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import ModifyUser from './ModifyUser';

const ModifyUserModal = ({ isOpen, onClose, userId, userType, isAdmin = false }) => {
    useEffect(() => {
        if (!isOpen) return;
        const prevOverflow = document.body.style.overflow;
        const prevPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
        return () => {
            document.body.style.overflow = prevOverflow;
            document.body.style.paddingRight = prevPaddingRight;
        };
    }, [isOpen]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    if (!isOpen) return null;

    const modalContent = (
        <div
            className="manage-users-modal-overlay"
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modify-user-modal-title"
        >
            <div className="manage-users-modal-box" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className="manage-users-modal-close"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <FaTimes />
                </button>
                <div className="manage-users-modal-body">
                    <ModifyUser userId={userId} userType={userType} isAdmin={isAdmin} />
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default ModifyUserModal;
